import fingers from '@amo/core/assets/images/icons/fingers.png';
import { getStepBySlug } from '../../../../../utils/function';

const ConfirmationDevis = (props) => {
    const { email, marque, pdfDevis, goTo } = props;

    return (
        <div id={'etape-confirm-devis'}>
            <div className={'row justify-content-center align-items-center mt-5'}>
                <div className={'col-lg-3 offset-lg-1 col-md-6 col-sm-16 col-12 my-2'}>
                    <img src={fingers} alt={'Confirmation devis'} />
                </div>
                <div className={'col-lg-5 col-md-6 col-sm-16 col-12 my-2 text-start text-dark'}>
                    <p className={'f-14'}>Votre devis vous a été envoyé à {email}</p>
                    <h2 className={'my-4'}>
                        N'attendez plus et assurez votre <strong className={'text-ternary'}>{marque}</strong>{' '}
                        immédiatement !
                    </h2>
                    <button
                        className={`btn btn-primary btn-smaller`}
                        onClick={() => goTo({ step: getStepBySlug('recapitulatif'), question: 1 })}
                    >
                        Je finalise mon avenant
                    </button>
                    <a href={pdfDevis} target={'_blank'} download className={'link-secondary f-12 d-block mt-2 ms-2'}>
                        Télécharger ma proposition d'assurance
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationDevis;
